import { getClientsOrganizations } from "modules/clientProjects/api";
import { useEffect, useState } from "react";
import isInList from "utils/isInList";

export default function useClients(clientInputValue) {
    const [clients, setClients] = useState([]);

    useEffect(() => {
        const fetchAllClients = async () => {
            try {
                const response = await getClientsOrganizations(clientInputValue);
                setClients(Object.values(response.entities.organizations || []));
            } catch (error) {
                console.error(error);
            }
        };
        if (!isInList(clients, clientInputValue, "attributes.name")) {
            fetchAllClients();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientInputValue]);

    return clients;
}
